import { useState, useEffect } from 'react';
import { useAuth } from '@/hooks/useAuth';
import { useOnboarding } from '@/hooks/useOnboarding';
import { GuidedOnboarding } from './GuidedOnboarding';

/**
 * Coordinates onboarding systems:
 * 1. Guided onboarding (interactive first-win flow)
 * 2. Onboarding tour (feature walkthrough)
 */
export const OnboardingCoordinator = () => {
  const { user } = useAuth();
  const { onboarding, loading } = useOnboarding();
  const [phase, setPhase] = useState<'idle' | 'guided' | 'done'>('idle');

  useEffect(() => {
    if (!user || loading) return;

    if (!onboarding.completed) {
      setPhase('guided');
    } else {
      setPhase('done');
    }
  }, [user, loading, onboarding.completed]);

  if (!user || phase === 'idle' || phase === 'done') return null;

  return (
    <>
      {phase === 'guided' && <GuidedOnboarding />}
    </>
  );
};
